export default "__VITE_ASSET__FYrPpjQ1__"